var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgExclamationOrange = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8 2C4.68629 2 2 4.68629 2 8C2 11.3137 4.68629 14 8 14C11.3137 14 14 11.3137 14 8C14 4.68629 11.3137 2 8 2ZM0 8C0 3.58172 3.58172 0 8 0C12.4183 0 16 3.58172 16 8C16 12.4183 12.4183 16 8 16C3.58172 16 0 12.4183 0 8ZM8 3.5C8.55229 3.5 9 3.94772 9 4.5V8C9 8.55228 8.55229 9 8 9C7.44772 9 7 8.55228 7 8V4.5C7 3.94772 7.44772 3.5 8 3.5ZM8 12.5C8.69036 12.5 9.25 11.9404 9.25 11.25C9.25 10.5596 8.69036 10 8 10C7.30964 10 6.75 10.5596 6.75 11.25C6.75 11.9404 7.30964 12.5 8 12.5Z",
    fill: "#F97700"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgExclamationOrange);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/exclamation_orange.7c2ac10eb9018502ce0bd9ed621cf81e.svg";